import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { LoginRequest } from './models/security/login-request.model';
import { LoginV2Response } from './models/security/login-v2-response.model';

export const AUTH_TOKEN_V2_STORAGE_KEY = 'jwt';
export const AUTH_TOKEN_V2_REFRESH_TOKEN = 'refreshToken';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {

  constructor(
    private readonly router: Router,
    private readonly http: HttpClient,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem(AUTH_TOKEN_V2_STORAGE_KEY) != null) {
      return true;
    }
    this.router.navigate(['/auth/login']).then();
    return false;
  }

  createAuthorizationHeader(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  login(login: LoginRequest): Observable<boolean> {
    return this.http.post<LoginV2Response>(environment.apiPathV2 + 'auth/login', login, {headers: this.createAuthorizationHeader()}).pipe(
      map(resp => {
        localStorage.setItem(AUTH_TOKEN_V2_STORAGE_KEY, resp.accessToken);
        localStorage.setItem(AUTH_TOKEN_V2_REFRESH_TOKEN, resp.refreshToken);
        return true;
      }),
      catchError(() => {
        localStorage.removeItem(AUTH_TOKEN_V2_STORAGE_KEY);
        localStorage.removeItem(AUTH_TOKEN_V2_REFRESH_TOKEN);
        return of(false);
      }),
    );
  }

  logout(): Observable<boolean> {
    localStorage.removeItem(AUTH_TOKEN_V2_STORAGE_KEY);
    localStorage.removeItem(AUTH_TOKEN_V2_REFRESH_TOKEN);
    return of(true);
  }
}
